import React from 'react';
import { Map } from 'immutable';
import { createTaskCategory, fetchTaskCategory, updateTaskCategory, fetchHandlers, fetchTrees, fetchPolicyRules } from '../../../apis';
import { Form } from '../../form/Form';

var dataSources = function dataSources(_ref) {
  var categoryName = _ref.categoryName;
  return {
    category: {
      fn: fetchTaskCategory,
      params: categoryName && [{
        categoryName: categoryName,
        include: 'details,handlers,trees,policyRules'
      }],
      transform: function transform(result) {
        return result.category;
      }
    },
    handlers: {
      fn: fetchHandlers,
      params: [{
        include: 'details'
      }],
      transform: function transform(result) {
        return result.handlers;
      }
    },
    routines: {
      fn: fetchTrees,
      params: [{
        type: 'Global Routine',
        include: 'details'
      }],
      transform: function transform(result) {
        return result.trees;
      }
    },
    policyRules: {
      fn: fetchPolicyRules,
      params: [{
        type: 'Category Access',
        include: 'details'
      }],
      transform: function transform(result) {
        return result.policyRules;
      }
    }
  };
};

var handleSubmit = function handleSubmit(_ref2) {
  var categoryName = _ref2.categoryName;
  return function (values) {
    return (categoryName ? updateTaskCategory : createTaskCategory)({
      category: values.toJS(),
      categoryName: categoryName
    }).then(function (_ref3) {
      var category = _ref3.category,
          error = _ref3.error;

      if (error) {
        throw error.statusCode === 400 && error.message || 'There was an error saving the category';
      }

      return category;
    });
  };
};

var fields = function fields(_ref4) {
  var categoryName = _ref4.categoryName;
  return function (_ref5) {
    var category = _ref5.category;
    return (!categoryName || category) && [{
      name: 'name',
      label: 'Name',
      type: 'text',
      required: true,
      initialValue: category ? category.get('name') : '',
      helpText: 'User friendly name for the category.'
    }, {
      name: 'description',
      label: 'Description',
      type: 'text',
      required: false,
      initialValue: category && category.get('description') !== null ? category.get('description') : ''
    }, {
      name: 'handlers',
      label: 'Handlers',
      type: 'select-multi',
      required: false,
      options: function options(_ref6) {
        var handlers = _ref6.handlers;
        return handlers ? handlers.map(function (handler) {
          return Map({
            label: handler.get('name'),
            value: handler.get('definitionId')
          });
        }) : [];
      },
      initialValue: category ? category.get('handlers').map(function (handler) {
        return handler.get('definitionId');
      }) : [],
      serialize: function serialize(_ref7) {
        var values = _ref7.values;
        return values.get('handlers').map(function (definitionId) {
          return definitionId;
        });
      }
    }, {
      name: 'trees',
      label: 'Global Routines',
      type: 'select-multi',
      required: false,
      options: function options(_ref8) {
        var routines = _ref8.routines;
        return routines ? routines.map(function (routine) {
          return Map({
            label: routine.get('name'),
            value: routine.get('definitionId')
          });
        }) : [];
      },
      initialValue: category ? category.get('trees').map(function (tree) {
        return tree.get('definitionId');
      }) : [],
      serialize: function serialize(_ref9) {
        var values = _ref9.values;
        return values.get('trees').map(function (definitionId) {
          return definitionId;
        });
      }
    }, {
      name: 'policyRules',
      label: 'Policy Rules',
      type: 'select-multi',
      required: false,
      options: function options(_ref10) {
        var policyRules = _ref10.policyRules;
        return policyRules ? policyRules.map(function (policyRule) {
          return Map({
            label: policyRule.get('name'),
            value: policyRule.get('name')
          });
        }) : [];
      },
      initialValue: category ? category.get('policyRules').map(function (policyRule) {
        return policyRule.get('name');
      }) : [],
      serialize: function serialize(_ref11) {
        var values = _ref11.values;
        return values.get('policyRules').map(function (name) {
          return name;
        });
      }
    }];
  };
};

export var TaskCategoryForm = function TaskCategoryForm(_ref12) {
  var addFields = _ref12.addFields,
      alterFields = _ref12.alterFields,
      fieldSet = _ref12.fieldSet,
      formKey = _ref12.formKey,
      components = _ref12.components,
      onSave = _ref12.onSave,
      onError = _ref12.onError,
      children = _ref12.children,
      categoryName = _ref12.categoryName;
  return /*#__PURE__*/React.createElement(Form, {
    addFields: addFields,
    alterFields: alterFields,
    fieldSet: fieldSet,
    formKey: formKey,
    components: components,
    onSubmit: handleSubmit,
    onSave: onSave,
    onError: onError,
    dataSources: dataSources,
    fields: fields,
    formOptions: {
      categoryName: categoryName
    }
  }, children);
};